<template>
  <div class="error">
    <div class="row">
      <div class="column column-100 header">
        {{ labels['errorTitle'] }}
      </div>
    </div>
    <div class="row">
      <div class="column column-100">
        {{ labels['errorMsg'] }}
      </div>
    </div>
    <div class="row">
      <div class="column column-100">
        <button class="button button-outline donate" @click="resetForm">
          {{ labels['resetForm'] }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS } from '@/settings'

export default {
  computed: mapState({
    lang: state => state.language,
    labels: state => LABELS[state.language]
  }),
  methods: {
    resetForm () {
      this.$store.dispatch('resetForm')
      const app = this.$root.$refs['oi-donate']
      app.finishTransaction(false)
    }
  }
}
</script>

<style scoped>
  .error .button {
    margin-top: 20px;
  }
</style>
